var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.02602 0.939084C5.40619 0.572613 6.00817 0.572613 6.38834 0.939083L13.4143 7.7118L6.38835 14.4845C6.00817 14.851 5.40619 14.851 5.02602 14.4845C4.62559 14.0985 4.62559 13.4573 5.02602 13.0713L10.5859 7.7118L5.02602 2.35234C4.62559 1.96635 4.62559 1.32508 5.02602 0.939084Z","fill":"#E8EFFF"})));
}

ArrowRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
